import React from 'react';

export const inputCls = 'w-full h-11 rounded-xl bg-white border border-slate-200 px-4 text-sm text-slate-900 placeholder:text-slate-400 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-[border-color,box-shadow]';

export const EditorCard = ({ Icon, title, desc, children, action, testId, className = '' }) => (
  <section data-testid={testId} className={`rounded-2xl bg-white border border-slate-200/80 shadow-sm p-5 sm:p-6 ${className}`}>
    <div className="flex flex-wrap items-start gap-3 mb-5">
      <span className="w-11 h-11 shrink-0 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center"><Icon className="w-5 h-5" /></span>
      <div className="flex-1 min-w-[200px]">
        <h2 className="text-base sm:text-lg font-extrabold text-slate-900">{title}</h2>
        {desc && <p className="text-xs sm:text-sm text-slate-500 mt-0.5">{desc}</p>}
      </div>
      {action}
    </div>
    {children}
  </section>
);

export const Field = ({ label, required, children }) => (
  <div className="block">
    <span className="block text-sm font-bold text-slate-700 mb-1.5">{label}{required && <span className="text-rose-500 ms-1">*</span>}</span>
    {children}
  </div>
);

export const Switch = ({ checked, onChange, testId }) => (
  <button type="button" role="switch" aria-checked={checked} data-testid={testId} onClick={() => onChange(!checked)}
    className={`relative w-12 h-7 shrink-0 rounded-full transition-colors ${checked ? 'bg-blue-600' : 'bg-slate-200'}`}>
    <span className={`absolute top-1 w-5 h-5 rounded-full bg-white shadow transition-[left] duration-200 ${checked ? 'left-6' : 'left-1'}`} />
  </button>
);
